import { render, staticRenderFns } from "./CatalogueForm.vue?vue&type=template&id=6f622276&scoped=true&"
import script from "./CatalogueForm.vue?vue&type=script&lang=js&"
export * from "./CatalogueForm.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueForm.vue?vue&type=style&index=0&id=6f622276&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f622276",
  null
  
)

component.options.__file = "CatalogueForm.vue"
export default component.exports